import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ReactiveFormsModule } from '@angular/forms'
import { MatDialogModule } from '@angular/material/dialog'
import { MatTooltipModule } from '@angular/material/tooltip'
import { NgSelectModule } from '@ng-select/ng-select'
import { StoreModule } from '@ngrx/store'
import { EffectsModule } from '@ngrx/effects'
import { EntityTagsEffects } from './store/effects'
import { EntityTagsGuard } from './store/guard'
import { tagsReducer } from './store/reducer'
import { EntityTagsService } from './store/service'
import { ManageEntityTagsDialogComponent } from './components/manage-entity-tags-dialog.component'
import { ManageEntityTagsDialogService } from './components/manage-entity-tags-dialog.service'

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatTooltipModule,
    NgSelectModule,
    StoreModule.forFeature('entityTags', tagsReducer),
    EffectsModule.forFeature([EntityTagsEffects]),
  ],
  declarations: [ManageEntityTagsDialogComponent],
  providers: [EntityTagsService, EntityTagsGuard, ManageEntityTagsDialogService],
  entryComponents: [ManageEntityTagsDialogComponent],
})
export class EntityTagsLibraryModule {}
